import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserAuth } from "../../utils/AuthContext";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import GoogleIcon from "@mui/icons-material/Google"; // Optional: import from MUI or use your SVG
import "./Login.css";

function Login({ pageRoute, toggle }) {
  // 1. Re-enable googleSignIn from your AuthContext
  const { login, setPending, googleSignIn } = UserAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showForm, setShowForm] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) return alert("Fill out all fields.");

    try {
      setError("");
      setPending(true);
      setShowForm(false); // Slide out form
      await login(email, password);
      setTimeout(() => navigate("/console"), 400); 
    } catch (e) {
      setError(e.message);
      setShowForm(true);
    } finally {
      setPending(false);
    }
  };

  // 2. New handler to handle the Google Sign-in flow smoothly
  const handleGoogleSignIn = async () => {
    try {
      setError("");
      setPending(true);
      setShowForm(false); // Slide out form on click
      await googleSignIn();
      setTimeout(() => navigate("/console"), 400);
    } catch (e) {
      setError(e.message);
      console.log(e.message);
      setShowForm(true); // Slide back in if error
    } finally {
      setPending(false);
    }
  };

  return (
    <>
      {!showForm && (
        <button className="login-btn" onClick={() => setShowForm(true)}>
          Login
        </button>
      )}

      <div className={`login_overlay ${showForm ? "active" : ""}`} onClick={() => setShowForm(false)}>
        <div className="login_wrapper" onClick={(e) => e.stopPropagation()}>
          <button type="button" className="close_btn" onClick={() => setShowForm(false)}>&times;</button>

          <form className="login" onSubmit={handleSubmit}>
            <input
              id="email"
              type="email"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <input
              id="password"
              type="password"
              placeholder="Password"
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <div className="col">
              <button type="submit">
                <LockOpenIcon />
              </button>
            </div>
          </form>

          {/* 3. Re-introduced Google Sign-in Divider & Button */}
          <div className="social_divider">
            <span>or</span>
          </div>

          <div className="social_sign_in_button google" onClick={handleGoogleSignIn}>
            <GoogleIcon className="google_icon" />
            <h1>Log in with Google</h1>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
